import type { ReactNode } from "react"
import { createContext } from "react"
import { DEFAULT_ACTIVITY_FEED_COLUMNS } from "./constants"
import type { ActivityFeedColumnControls } from "./types"

type ActivityFeedColumnsProviderProps = {
  children: ReactNode
  columns: ActivityFeedColumnControls
}

export const ActivityFeedColumnsContext =
  createContext<ActivityFeedColumnControls>(DEFAULT_ACTIVITY_FEED_COLUMNS)

export function ActivityFeedColumnsProvider({
  children,
  columns,
}: ActivityFeedColumnsProviderProps) {
  return (
    <ActivityFeedColumnsContext.Provider value={columns}>
      {children}
    </ActivityFeedColumnsContext.Provider>
  )
}
